import { config } from '@/config/tim-config';
import { YXTIM } from '@yunxi/tim';

export const tim = new YXTIM({
  ...config,
});
